import React from 'react'

function GoogleMap() {
  return (
    <div>
         <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <iframe className="iframe-fluid mb-2" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Berhampore%20Laser%20Sitting%20Centre,%20122,%20Pilkhana%20Rd,%20Ranibagan,%20Khagra,%20Berhampore,%20West%20Bengal%20742101%20+(Berhampore%20Laser%20Sitting%20Centre,%20122,%20Pilkhana%20Rd,%20Ranibagan,%20Khagra,%20Berhampore,%20West%20Bengal%20742101)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe> 
                    </div>
                </div>
            </div>
    </div>
  )
}

export default GoogleMap